import { Button } from "antd";
import type { ModalHandle } from "../modal";
import type { FC, RefObject } from "react";
import { useTranslation } from "utils/hooks";

interface IModalCloseButton {
  modalRef: RefObject<ModalHandle>;
  outline?: boolean;
}
export const ModalCloseButton: FC<IModalCloseButton> = ({
  modalRef,
  outline = false,
}) => {
  const { t } = useTranslation("button");
  const close = () => {
    modalRef.current?.close();
  };
  return (
    <Button
      type={outline ? "primary" : undefined}
      ghost={outline}
      onClick={close}
    >
      {t("close")}
    </Button>
  );
};
